import { render, staticRenderFns } from "./SM-Button-Group.vue?vue&type=template&id=15f6b222"
import script from "./SM-Button-Group.vue?vue&type=script&lang=js"
export * from "./SM-Button-Group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports